import API from 'services/api';

export const deletePolicy = ({ policyId }: { policyId: string }) => {
  return API.delete(`/api/accommodation/cancellation-policy/${policyId}`);
};
